import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "login"
};
const _hoisted_2 = {
  class: "tab-title"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "form-box"
};
const _hoisted_5 = {
  class: "login-bottom"
};
const _hoisted_6 = ["innerHTML"];
import { ref, reactive, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getCode, loginVerification, loginPwd } from '@/api/login';
import { updateUser } from '@/api/user';
import { setToken } from '@/utils/auth';
import { useStore } from 'vuex';
import yinsi from "@/docs/yinsi";
import yonghu from "@/docs/yonghu";

import { showConfirmDialog, showFailToast, showNotify } from 'vant/es';
import 'vant/es/dialog/style/index';
import 'vant/es/toast/style/index';
import 'vant/es/notify/style/index';
const __default__ = {
  name: "login"
};
export default /*@__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const [route, router] = [useRoute(), useRouter()];
    const store = useStore();
    const isPhone = /^1[3-9]\d{9}$/;
    const loginTypeList = [{
      type: 1,
      label: "验证码登录"
    }, {
      type: 2,
      label: "账户密码登录"
    }];
    const loginType = ref(1);
    let formData = reactive({});
    const checked = ref(false);
    const activeShow = ref(false);
    const agreement = reactive({
      title: "标题",
      content: "内容"
    });
    const loginLoading = ref(false);
    const time = ref(0);
    const sendStr = ref("发送验证码");

    // 切换登录方式
    const changeType = type => {
      loginType.value = type;
      delete formData.code;
      delete formData.password;
    };

    // 获取用户协议
    const showUserAgree = () => {
      activeShow.value = true;
      agreement.title = "用户协议";
      agreement.content = yonghu;
    };

    // 获取隐私协议
    const showPrivacyArgee = () => {
      activeShow.value = true;
      agreement.title = "隐私协议";
      agreement.content = yinsi;
    };

    // 获取验证码
    const sendCode = async () => {
      if (isPhone.test(formData.phone)) {
        const data = {
          phone: formData.phone
        };
        const res = await getCode(data);
        if (res.code === 200) {
          showNotify({
            type: "success",
            message: "验证码发送成功"
          });
          time.value = 60;
          const interval = setInterval(() => {
            time.value--;
            if (time.value === 0) {
              clearInterval(interval);
            }
          }, 1000);
        } else {
          showNotify({
            type: "warning",
            message: "验证码发送失败，请稍后重试",
            color: '#FFF',
            background: '#7f7f7f'
          });
        }
      }
    };
    const showBack = computed(() => {
      return route.name === "changeUser";
    });
    const login = async () => {
      if (!checked.value) {
        try {
          await showConfirmDialog({
            title: "提示",
            message: "登录请确认是否同意《用户协议》和《隐私协议》。"
          });
        } catch (e) {
          return "用户拒绝";
        }
      }
      checked.value = true;
      loginLoading.value = true;
      const params = {
        phone: formData.phone
      };
      let token;
      const redirect = route.query?.redirect || "/";
      let fn = function () {};
      switch (loginType.value) {
        case 1:
          params.verificationCode = formData.code;
          fn = loginVerification;
          break;
        case 2:
          fn = loginPwd;
          params.password = formData.password;
          break;
      }
      fn(params).then(async res => {
        if (res.code === 200) {
          token = res.data?.token;
          if (!token) {
            showFailToast("登录失败");
            return loginLoading.value = false;
          }
          setToken(token);
          if (res.data.isNew && loginType.value === 1) {
            const num = Date.now() % 100000;
            const params = {
              nickname: "用户" + num + formData.phone.substr(7),
              avatar: null,
              tags: null
            };
            await updateUser(params);
          }
          store.dispatch("clearUser");
          setTimeout(() => {
            router.replace(redirect);
          }, 500);
        } else {
          delete formData.code;
          showFailToast(res.data.msg);
        }
        loginLoading.value = false;
      }).catch(e => {
        // console.log(e)
        loginLoading.value = false;
      });
    };
    const sendCodeDisabled = computed(() => {
      return time.value > 0;
    });
    const loginDisabled = computed(() => {
      const hasPhone = formData.phone;
      const hasCodeOrPwd = formData.code || formData.password;
      return !(hasPhone && hasCodeOrPwd);
    });
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_checkbox = _resolveComponent("van-checkbox");
      const _component_van_action_sheet = _resolveComponent("van-action-sheet");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(loginTypeList, item => {
        return _createElementVNode("li", {
          key: item.type,
          class: _normalizeClass({
            active: loginType.value === item.type
          }),
          onClick: $event => changeType(item.type)
        }, _toDisplayString(item.label), 11, _hoisted_3);
      }), 64))]), _createVNode(_component_van_form, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_field, {
          class: "cell",
          modelValue: _unref(formData).phone,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).phone = $event),
          label: "+86",
          placeholder: "请输入手机号",
          rules: [{
            pattern: isPhone,
            message: '请输入正确的手机号'
          }]
        }, null, 8, ["modelValue", "rules"]), loginType.value === 1 ? (_openBlock(), _createBlock(_component_van_field, {
          key: 0,
          class: "cell",
          modelValue: _unref(formData).code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).code = $event),
          label: "验证码",
          placeholder: "请输入验证码"
        }, {
          button: _withCtx(() => [_createVNode(_component_van_button, {
            class: "send-btn",
            size: "small",
            type: "primary",
            onClick: sendCode,
            disabled: sendCodeDisabled.value
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(time.value > 0 ? time.value : sendStr.value), 1)]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }, 8, ["modelValue"])) : loginType.value === 2 ? (_openBlock(), _createBlock(_component_van_field, {
          key: 1,
          class: "cell",
          type: "password",
          modelValue: _unref(formData).password,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).password = $event),
          label: "密码",
          placeholder: "请输入密码"
        }, null, 8, ["modelValue"])) : _createCommentVNode("", true)])]),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_checkbox, {
        modelValue: checked.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => checked.value = $event),
        class: "mb-20"
      }, {
        default: _withCtx(() => [_cache[6] || (_cache[6] = _createTextVNode(" 我已阅读并同意 ")), _createElementVNode("a", {
          href: "javascript:;",
          onClick: _withModifiers(showUserAgree, ["stop"])
        }, "《用户协议》"), _cache[7] || (_cache[7] = _createTextVNode("、 ")), _createElementVNode("a", {
          href: "javascript:;",
          onClick: _withModifiers(showPrivacyArgee, ["stop"])
        }, "《隐私协议》")]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_van_button, {
        disabled: loginDisabled.value,
        type: "primary",
        class: "w-full",
        onClick: login,
        loading: loginLoading.value
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode(" 登录 ")])),
        _: 1
      }, 8, ["disabled", "loading"]), showBack.value ? (_openBlock(), _createBlock(_component_van_button, {
        key: 0,
        class: "w-full back",
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).back())
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("返回")])),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_van_action_sheet, {
        show: activeShow.value,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => activeShow.value = $event),
        title: agreement.title
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "content",
          innerHTML: agreement.content
        }, null, 8, _hoisted_6)]),
        _: 1
      }, 8, ["show", "title"])]);
    };
  }
});